export enum ProgressStatus {
    LOAD = 'load',
    ERROR = 'error',
    EMPTY = 'empty',
    SUCCESS = 'success'
}
